import { PaymentMethod, PaymentMethodProviderType } from '@40seas/entities/payment-methods';
import Stripe from 'stripe';

import { achPaymentMethodTypeHandler } from './ach-stripe-payment-method.handler';
import { acssPaymentMethodTypeHandler } from './acss-stripe-payment-method.handler';
import { bacsPaymentMethodTypeHandler } from './bacs-stripe-payment-method.handler';
import { cardPaymentMethodTypeHandler } from './card-stripe-payment-method.handler';
import { cryptoPaymentMethodTypeHandler } from './crypto-stripe-payment-method.handler';

type PaymentMethodTypeHandler = (
    stripePaymentMethod: Stripe.PaymentMethod,
    partialPaymentMethod: Partial<PaymentMethod>,
    stripeCharge?: Stripe.Charge,
) => PaymentMethod;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore - Fix TS FS-3199
const paymentMethodTypeToHandler = new Map<string, PaymentMethodTypeHandler>([
    ['acss_debit', acssPaymentMethodTypeHandler.bind(this)],
    ['card', cardPaymentMethodTypeHandler.bind(this)],
    ['us_bank_account', achPaymentMethodTypeHandler.bind(this)],
    ['bacs_debit', bacsPaymentMethodTypeHandler.bind(this)],
    ['crypto', cryptoPaymentMethodTypeHandler.bind(this)],
]);

export async function stripePaymentMethodMapper(
    stripePaymentMethod: Stripe.PaymentMethod,
    paymentMethodParams: Partial<PaymentMethod>,
    stripeCharge?: Stripe.Charge,
): Promise<Partial<PaymentMethod>> {
    const partialPaymentMethod = {
        ...paymentMethodParams,
        providerType: PaymentMethodProviderType.Stripe,
        providerId: stripePaymentMethod.id,
    };
    const handler = paymentMethodTypeToHandler.get(stripePaymentMethod.type);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    const paymentMethodTypeFields = await handler(stripePaymentMethod, partialPaymentMethod, stripeCharge);

    return {
        ...partialPaymentMethod,
        methodType: paymentMethodTypeFields.methodType,
        methodTypeFields: paymentMethodTypeFields.methodTypeFields,
    };
}
